import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave/list`);
  return response;
};

const getAllComplete = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave/get/all`);
  return response;
};

const getAllActive = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave/get/active`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave/${id}`);
  return response;
};

const getByOdooId = async (odooId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_timeleave/odoo/${odooId}`);
  return response;
};

const insert = async (data) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_timeleave/manual/create`, data);
  return response;
}

const update = async (id, data) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_timeleave/${id}`, data);
  return response;
}

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}odoo_timeleave/${id}`);
  return response;
}

export {getAll, getList,getAllComplete,getAllActive,getById,getByOdooId, insert, update, drop};